import "./EmployeeCard.css";

interface EmployeeCardProps {
  firstName?: string;
  lastName?: string;
  employeeId?: string;
  type?: string;
  companyName?: string;
}

const EmployeeCard = ({
  firstName,
  lastName,
  employeeId,
  type,
  companyName,
}: EmployeeCardProps) => {
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();

  return (
    <div className="employee-card">
      {fullName && <div className="employee-card-name-label">{fullName}</div>}
      {employeeId && (
        <div className="employee-card-id-label">
          ID
          <br />
          {employeeId}
        </div>
      )}
      <div className="employee-card-images">
        <img
          src="/Frame 29611912.svg"
          alt="Frame 29611912"
          className="employee-card-top-image"
        />
        <img
          src="/Premium Club.svg"
          alt="Premium Club"
          className="employee-card-bottom-image"
        />
        <div className="employee-card-label">Exclusive Privileges</div>
      </div>
      {type && <div className="employee-card-type-label">{type}</div>}
      {companyName && (
        <div className="employee-card-company-label">{companyName}</div>
      )}
    </div>
  );
};

export default EmployeeCard;
